/* Presentation enrichment only: vendor membership and shopping links remain server-rendered. */
class SITCBrandLogoPages extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.loadPages();
  }
  disconnectedCallback() { this.controller?.abort(); }
  async loadPages() {
    const {signal} = this.controller;
    const targets = new Map([...this.querySelectorAll('[data-brand-logo]')].map(el => [el.dataset.brandLogo, el]));
    const seen = new Set();
    let next = this.dataset.next;
    while (next && !signal.aborted) {
      const url = new URL(next, location.origin);
      if (url.origin !== location.origin || seen.has(url.href)) return;
      seen.add(url.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, {signal, credentials:'same-origin'});
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (signal.aborted) return;
        const source = [...parsed.querySelectorAll('sitc-brand-logo-pages')].find(el => el.dataset.sectionId === this.dataset.sectionId);
        if (!source) return;
        for (const incoming of source.querySelectorAll('[data-brand-logo]')) {
          const target = targets.get(incoming.dataset.brandLogo);
          if (!target || !incoming.querySelector('img') || target.dataset.brandIdentity !== incoming.dataset.brandIdentity) continue;
          const replacement = document.importNode(incoming, true);
          target.replaceWith(replacement);
          targets.set(incoming.dataset.brandLogo, replacement);
        }
        next = source.dataset.next;
      } catch {
        // Complete vendor names and links remain usable if optional image enrichment fails.
        return;
      }
    }
  }
}
if (!customElements.get('sitc-brand-logo-pages')) customElements.define('sitc-brand-logo-pages', SITCBrandLogoPages);

